import { render, staticRenderFns } from "./BaseTableCell.vue?vue&type=template&id=f186c9a0"
import script from "./BaseTableCell.vue?vue&type=script&lang=js"
export * from "./BaseTableCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports